<a class="dnlLink" href="javascript:void(0)" (click)="onLinkClick($event)">
  {{paramsValue}}
</a>
<p-toast key="d2DfileDownload" position="center" [style]="{ marginTop : '100px', width: '400px' }" [closable]="true" [baseZIndex]="500" [autoZIndex]="100" [hideTransitionOptions]="'250ms'">
  <ng-template let-message pTemplate="message">
      <div style="text-align: center">
          <h3>{{message.summary | translate}}</h3>
          <p>{{message.detail | translate}}</p>
      </div>
  </ng-template>
</p-toast>
<p-toast key="downloadError" position="center" [style]="{ marginTop : '100px', width: '400px' }" [closable]="true"  [baseZIndex]="500" [autoZIndex]="100" [hideTransitionOptions]="'250ms'">
  <ng-template let-message pTemplate="message">
      <div style="text-align: center">
          <h3>{{message.summary | translate}}</h3>
          <p>{{message.detail | translate}}</p>
      </div>
  </ng-template>
</p-toast>